import { useTranslation } from "react-i18next";
import classes from "./PDFview.module.css";
import { useState, useEffect } from "react";
import axiosClient from "../services/axiosClient";
import downloadIcon from "../assets/download-icon.svg";
import CustomButton from "./CustomButton";

const PDFViewer = ({
  path,
  filename,
  fileType: defaultFileType,
  downloadable = false,
  fileSubname,
}) => {
  const { t } = useTranslation("general");
  const [fileUrl, setFileUrl] = useState();
  const [error, setError] = useState(null);
  const [fileType, setFileType] = useState(defaultFileType);
  const filesExtensionsMap = {
    pdf: "application/pdf",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    document: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    sheet: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  };

  const fetchFile = async () => {
    try {
      const response = await axiosClient.get(path, {
        responseType: "blob",
      });

      if (!response.data) {
        throw new Error("No data received");
      }

      const blob = new Blob([response.data], {
        type:
          filesExtensionsMap[fileType],
      });

      const url = window.URL.createObjectURL(blob);
      setFileUrl(url);
      setError(null);
    } catch (error) {
      console.error("Error fetching file:", error);
      setError("errorViewFile");
    }
  };

  const handleDownloadFile = () => {
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;
      link.click();
    }
  };

  useEffect(() => {
    if (path) {
      fetchFile();
    }
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [path]);

  if (error) {
    return <div className={classes.error}>{t(error)}</div>;
  }

  if (!fileUrl) {
    return <div className={classes.loading}>{t("loading")}</div>;
  }

  const isNotSupportedFile = fileType !== "pdf";

  return (
    <div className={`${classes.mainDiv} `}>
      <div
        className="t-bold_semi-bold"
        style={{
          // width: "max-content",
        }}
      >
        <span>{t(filename)}</span>
        <br />
        <div className="t-text-mini neutral-value o-row o-row--horizontal-align_center">
          {t(fileSubname)}
        </div>
      </div>
      {isNotSupportedFile && (
        <div className="u-height_full-height u-margin--top_200">
        <CustomButton
          title={t("downloadFile")}
          icon={downloadIcon}
          iconSize={18}
          onClick={handleDownloadFile}
          variant={"blank"}
          />
          </div>
      )}
      {!isNotSupportedFile && (
        <div
          className={`${downloadable ? classes.downloadable : ""}`}
          style={{
            position: "relative",
          }}
        >
          <div
            className={`${classes.overlay} `}
            onClick={() => window.open(fileUrl, "_blank")}
          ></div>

          <iframe
            src={`${fileUrl}#toolbar=0&navpanes=0`}
            title={filename}
            className={classes.iframe}
            onError={(e) => {
              console.error("Error loading iframe:", e);
              setError("errorViewFile");
            }}
          />

          {downloadable && (
            <img
              src={downloadIcon}
              alt="Download"
              className={classes.deleteIcon}
              onClick={handleDownloadFile}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default PDFViewer;
